import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useEffect, useState } from "react";
import "./App.css";

import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Mobilemenu from "./components/Mobilemenu";
import Top from "./components/Top";
import ScrollToTop from "./components/ScrollToTop";
import Loader from "./components/Loader";
import NotFound from "./components/NotFound";
import PageTitle from "./components/PageTitle";

import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Services from "./pages/Services/Services";
import ServicesDetails from "./pages/ServicesDetails/ServicesDetails";
import Portfolio from "./pages/Portfolio/Portfolio";
import PortfolioDetails from "./pages/PortfolioDetails/PortfolioDetails";
import Blog from "./pages/Blog/Blog";
import BlogDetails from "./pages/BlogDetails/BlogDetails";
import Contact from "./pages/Contact/Contact";
import Team from "./pages/Team/Team";
import TeamDetails from "./pages/TeamDetails/TeamDetails";
import Gallery from "./pages/Gallery/Gallery";
import Pricing from "./pages/Pricing/Pricing";
import Faq from "./pages/Faq/Faq";

function App() {
  const [loading, setLoading] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen((prev) => !prev);
  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Loader />;

  return (
    <BrowserRouter>
      <div className="App">
        <Mobilemenu closeMenu={closeMenu} menuOpen={menuOpen} />
        <Header toggleMenu={toggleMenu} />

        <Routes>
          <Route
            path="/"
            element={
              <>
                <PageTitle title="HOME" /> <Home />
              </>
            }
          />

          <Route
            path="/about"
            element={
              <>
                <PageTitle title="ABOUT US" /> <About />
              </>
            }
          />

          <Route
            path="/services"
            element={
              <>
                <PageTitle title="SERVICES" /> <Services />
              </>
            }
          />
          <Route
            path="/services/service-details/:id"
            element={
              <>
                <PageTitle title="SERVICES DETAILS" /> <ServicesDetails />
              </>
            }
          />

          <Route
            path="/portfolio"
            element={
              <>
                <PageTitle title="PORTFOLIO" /> <Portfolio />
              </>
            }
          />
          <Route
            path="/portfolio/portfolio-details/:id"
            element={
              <>
                <PageTitle title="PORTFOLIO DETAILS" /> <PortfolioDetails />
              </>
            }
          />

          <Route
            path="/blog"
            element={
              <>
                <PageTitle title="BLOG" /> <Blog />
              </>
            }
          />
          <Route
            path="/blog/blog-details/:id"
            element={
              <>
                <PageTitle title="BLOG DETAILS" /> <BlogDetails />
              </>
            }
          />

          <Route
            path="/contact"
            element={
              <>
                <PageTitle title="CONTACT" /> <Contact />
              </>
            }
          />

          <Route
            path="/team"
            element={
              <>
                <PageTitle title="TEAM" /> <Team />
              </>
            }
          />
          <Route
            path="/team/team-details/:id"
            element={
              <>
                <PageTitle title="TEAM DETAILS" /> <TeamDetails />
              </>
            }
          />

          <Route
            path="/gallery"
            element={
              <>
                <PageTitle title="GALLARY" /> <Gallery />
              </>
            }
          />

          <Route
            path="/pricing"
            element={
              <>
                <PageTitle title="PRICING" /> <Pricing />
              </>
            }
          />

          <Route
            path="/faq"
            element={
              <>
                <PageTitle title="FAQ" /> <Faq />
              </>
            }
          />

          <Route
            path="*"
            element={
              <>
                <PageTitle title="NOTFOUND" /> <NotFound />
              </>
            }
          />
        </Routes>

        <Footer />
        <ScrollToTop />
        <Top />
      </div>
    </BrowserRouter>
  );
}

export default App;
